/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Request_BodyInputs */

const en_password_reset_request_body = /** @type {(inputs: Password_Reset_Request_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the email you use for Listening and we'll send you a link to set a new password.`)
};

const es_password_reset_request_body = /** @type {(inputs: Password_Reset_Request_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce el correo que usas en Listening y te enviaremos un enlace para crear una contraseña nueva.`)
};

/**
* | output |
* | --- |
* | "Enter the email you use for Listening and we'll send you a link to set a new password." |
*
* @param {Password_Reset_Request_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_request_body = /** @type {((inputs?: Password_Reset_Request_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Request_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_request_body(inputs)
	return en_password_reset_request_body(inputs)
});